// extracted by mini-css-extract-plugin
module.exports = {"menuBackButton":"u2lkdu"};